import { initializeRouteChangeHandler } from './initializeRouteChangeHandler';
import { routes } from './routes';
import './style.css';
import { getQueryElement, getContentElement } from './elements';
import { renderResult } from './renderResult';

// Function to handle route changes
const handleRouteChange = () => {
    const newPath = window.location.pathname;
    const route = routes[newPath];
    if (!route) {
        window.location.pathname = '/';
        return;
    }

    window.document.title = route.title;
    const queryElement = getQueryElement();
    queryElement.value = route.query;
    queryElement.dispatchEvent(new Event('input'));
    document.querySelectorAll('.top-menu a').forEach((link) => {
        if (link.getAttribute('href') === newPath) {
            link.classList.add('active');
        } else {
            link.classList.remove('active');
        }
    });
};
initializeRouteChangeHandler(handleRouteChange);

const fetchData = async () => {
    const queryElement = getQueryElement();
    const contentElement = getContentElement();

    const response = await fetch(import.meta.env.VITE_GRAPHQL_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query: queryElement.value }),
    });
    const responseBody = await response.json();
    contentElement.innerHTML = renderResult(responseBody);
    contentElement.classList.remove('loading');
};

window.addEventListener('DOMContentLoaded', () => {
    const queryElement = getQueryElement();
    const contentElement = getContentElement();
    queryElement.addEventListener('input', () => {
        contentElement.classList.add('loading');
        fetchData();
    });
    queryElement.dispatchEvent(new Event('input'));
});
